export default __webpack_public_path__ + "static/media/img-time-l-1.5be8f2ee.svg";